var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/24/Account-Manager",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,9 C11.6568542,9 13,7.65685425 13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 C7,7.65685425 8.34314575,9 10,9 Z M10,11 C7.23857625,11 5,8.76142375 5,6 C5,3.23857625 7.23857625,1 10,1 C12.7614237,1 15,3.23857625 15,6 C15,8.76142375 12.7614237,11 10,11 Z M17.0004272,24 C17.0004272,16.9377441 16.5253906,15 9.5,15 C2.47460937,15 2.01379395,17.1992187 2.01379395,24 L1.77635684e-15,24 C1.77635684e-15,17.1992187 0.432373047,13 9.5,13 C18.567627,13 19,16.9377441 19,24 L17.0004272,24 Z M22,6 L24,6 L24,8 L22,8 L22,6 Z M18,2 L20,2 L20,4 L18,4 L18,2 Z M18,6 L20,6 L20,8 L18,8 L18,6 Z M9,17 L11,17 L11,24 L9,24 L9,17 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,10 L24,10 L24,12 L22,12 L22,10 Z M22,14 L24,14 L24,16 L22,16 L22,14 Z M18,10 L20,10 L20,12 L18,12 L18,10 Z",
    id: "Combined-Shape",
    fill: "#CE0E2D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountManager);
export default __webpack_public_path__ + "static/media/account-manager.60e3fee3413d168336ec5ca645e884d7.svg";
export { ForwardRef as ReactComponent };